export default "__VITE_ASSET__D3u4IkNn__"